import { DateField as RaDateField, DateFieldProps as RaDateFieldProps } from 'react-admin';

export const DateField = RaDateField;

export type DateFieldProps = RaDateFieldProps;
